import {SHOW_POPUP_WITH_INPUT, HIDE_POPUP_WITH_INPUT} from '@/store/mutation-types'

const state = {
	popupWithWindow: null
}

const getters = {
	hasPopupWithInput: state => state.popupWithWindow !== null,
	getPopupWithInputMessage: state => state.popupWithWindow.message,
	getPopupWithInputSubmitButtonText: state => state.popupWithWindow.buttonText,
	getPopupWithInputDefaultInputValue: state => state.popupWithWindow.defaultInputValue,
	getPopupWithInputData: state => state.popupWithWindow.data,
	getPopupWithInputAction: state => state.popupWithWindow.action,
}

const actions = {
	[SHOW_POPUP_WITH_INPUT]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SHOW_POPUP_WITH_INPUT, data)
			resolve()
		})
	},
	[HIDE_POPUP_WITH_INPUT]: ({commit, dispatch}) => {
		return new Promise((resolve, reject) => {
			commit(HIDE_POPUP_WITH_INPUT)
			resolve()
		})
	}
}

const mutations = {
	[SHOW_POPUP_WITH_INPUT]: (state, data) => {
		state.popupWithWindow = data;
	},
	[HIDE_POPUP_WITH_INPUT]: (state) => {
		state.popupWithWindow = null;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/popupWithInput.js